/**
 * Implementazione dello scrolling orizzontale con il mouse wheel per la kanban
 * Questo script aggiunge la funzionalità di scroll orizzontale quando si usa la rotella del mouse
 * tenendo premuto il tasto Shift (comportamento standard) mantenendo lo scroll verticale normale
 */

(function() {
    /**
     * Imposta un handler per l'evento wheel sulla kanban
     */
    function setupHorizontalScroll() {
        // Seleziona l'elemento kanban
        const kanbanContainer = document.querySelector('.projects-division');
        
        // Se l'elemento kanban non esiste, esci dalla funzione
        if (!kanbanContainer) return;
        
        // Aggiungi l'evento wheel
        kanbanContainer.addEventListener('wheel', function(event) {
            // Verifica se c'è contenuto scrollabile orizzontalmente
            const canScrollHorizontally = this.scrollWidth > this.clientWidth;
            
            if (!canScrollHorizontally) return;
            
            // Se l'utente preme Shift, usa deltaY per lo scroll orizzontale (comportamento standard)
            if (event.shiftKey && event.deltaY !== 0) {
                // Previeni lo scroll verticale predefinito solo quando Shift è premuto
                event.preventDefault();
                
                // Calcola la quantità di scroll
                const scrollAmount = event.deltaY;
                const scaleFactor = 0.5; // Fattore di scala per rendere lo scroll più fluido
                
                // Applica lo scroll orizzontale
                this.scrollLeft += scrollAmount * scaleFactor;
                return;
            }
            
            // Verifica se c'è contenuto scrollabile verticalmente in una delle colonne
            const kanbanCols = this.querySelectorAll('.kanban-col');
            let hasVerticalScroll = false;
            
            for (let col of kanbanCols) {
                if (col.scrollHeight > col.clientHeight) {
                    hasVerticalScroll = true;
                    break;
                }
            }
            
            // Se non c'è scroll verticale necessario e c'è deltaY (scroll verticale del mouse),
            // converti lo scroll verticale in orizzontale
            if (!hasVerticalScroll && event.deltaY !== 0 && !event.deltaX) {
                event.preventDefault();
                
                // Calcola la quantità di scroll
                const scrollAmount = event.deltaY;
                const scaleFactor = 0.5; // Fattore di scala per rendere lo scroll più fluido
                
                // Applica lo scroll orizzontale
                this.scrollLeft += scrollAmount * scaleFactor;
            }
        }, { passive: false });
    }
    
    // Esegui la funzione quando il DOM è completamente caricato
    document.addEventListener('DOMContentLoaded', setupHorizontalScroll);
    
    // Esegui anche quando il contenuto è caricato dinamicamente (per Vue/SPA)
    window.addEventListener('load', setupHorizontalScroll);
    
    // Per gestire gli aggiornamenti dinamici delle viste
    document.addEventListener('vue-mounted', setupHorizontalScroll);
})(); 